import React, { Component } from 'react';
import { Button, Spin, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import Filter from './Filter';
import { AddComment } from '../AddComment';
import TableC from '../../basicElement/TableC';
import SideNav from '../SumEffSider';
import moment from 'moment';

const dateFormat = "YYYY-MM-DD";

class WeeklySummary extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            begin: sessionStorage.curRole === 'CRC' ? moment().subtract(3, 'M').set('date', 1).format(dateFormat) : moment().subtract(11, 'M').set('date', 1).format(dateFormat),
            end: sessionStorage.curRole === 'CRC' ? moment().set('date', 1).format(dateFormat) :  moment().add(1, 'M').set('date', 1).format(dateFormat),
        };
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams,
            curParams: { ...searchParams },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            currentDate: '',
        }
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
        this.getDate();
    }

    // 获取系统时间
    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({ currentDate: date });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.querySummary,
            data: {
                offset: current,
                limit: pageSize - 1,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { total, dataList: { datas, totalCount } } = res.data;
                const ct = Number((totalCount / (pageSize - 1)).toFixed(0)) + (totalCount % (pageSize - 1) > 0 ? 1 : 0);
                pagination.total = totalCount + ct;

                const data = datas || [];
                if (data.length) {
                    data.push({
                        ...total,
                        showDate: '汇总',
                    });
                }

                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.summary.exportSummary;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        dictCache.getDict(`INV_STAGE_${investigationId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.investigation.queryInvestigationStageByInvId,
                data: { investigationId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { data } = res;
            this.setState({
                invStageList: data,
            });
        });
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }


    getColumns = () => {
        const { blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const columns = [{
            title: '时间段',
            dataIndex: 'showDate',
            key: 'showDate',
            sorter: true,
            width: 140,
            fixed: 'left',
        }, {
            title: '本周工时数',
            dataIndex: 'manHourString',
            key: 'manHourString',
            sorter: true,
            width: 120,
            render: text => text ? `${text}h` : '',
        }, {
            title: '本周FTE数',
            dataIndex: 'fteString',
            key: 'fteString',
            sorter: true,
            width: 120,
        }]
        if (!isUnBlind) {
            columns.push({
                title: '本周筛选数',
                dataIndex: 'amountFilter',
                key: 'amountFilter',
                sorter: true,
                width: 120,
            }, {
                title: '本周知情数',
                dataIndex: 'amountInformed',
                key: 'amountInformed',
                sorter: true,
                width: 120,
            }, {
                title: '本周随机(入组)数',
                dataIndex: 'amountRandom',
                key: 'amountRandom',
                sorter: true,
                width: 130,
            });
        }
        columns.push({
            title: '本周完成访视数',
            dataIndex: 'amountVisit',
            key: 'amountVisit',
            width: 130,
        }, {
            title: '本周退出数',
            dataIndex: 'amountDrop',
            key: 'amountDrop',
            sorter: true,
            width: 120,
        }, {
            title: '本周方案违背数',
            dataIndex: 'amountViolation',
            key: 'amountViolation',
            sorter: true,
            width: 130,
        }, {
            title: '本周重大事件数',
            dataIndex: 'amountMajorEvent',
            key: 'amountMajorEvent',
            sorter: true,
            width: 130,
        });
        if (!isUnBlind) {
            columns.push({
                title: '本周SAE数',
                dataIndex: 'amountSae',
                key: 'amountSae',
                sorter: true,
                width: 120,
            });
        }
        columns.push({
            title: '备注',
            dataIndex: 'comment',
            key: 'comment',
            width: 200,
        }, {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            width: 130,
        });
        const { siteId, curRole } = sessionStorage;
        if (((curRole == "PM" || curRole == "PA") && siteId == 0) || (curRole == "CRC" && siteId > 0)) {
            columns.push({
                title: '操作',
                key: 'operate',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    const { comment, investigationSiteWeekSummaryId } = record;
                    return (
                        investigationSiteWeekSummaryId > 0 &&
                        <a onClick={()=>this.canEditByInvStatus(() => this.showComment(investigationSiteWeekSummaryId, comment))}>填写备注</a>
                    );
                },
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showComment = (id, comment) => {
        this.addCommentRef.show(id, comment);
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, currentDate } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="weeklySummary" />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        currentDate={currentDate}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>
                        ]}
                    />
                    <TableC
                        data={data}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        className="weeklySummary"
                    />
                    <AddComment ref={el => this.addCommentRef = el} reload={this.loadData} />
                </div>
            </div>
        );
    }
}

export default WeeklySummary;


// WEBPACK FOOTER //
// ./src/components/sumTotal/weeklySummary/index.js